module.exports = __webpack_public_path__ + "static/media/439JamesPBrawleyDrNW_2018-06-12_84.4289eba8.jpg";